export enum LoaderConstants {
  SHOW_LOADER = 'SHOW_LOADER',
  HIDE_LOADER = 'HIDE_LOADER',
  RESET_LOADER = 'RESET_LOADER',
}
